export default "__VITE_ASSET__3PvPb_4T__"